/* eslint-disable */
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const DisclaimerPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,
};

export default DisclaimerPropTypes;
